import { useState } from "react";
import { ShieldCheck, CircleNotch, CaretDown } from "@phosphor-icons/react";

const KIND_LABEL = { injury: "ICD-10-CM", procedure: "ICD-10-PCS", external: "External", ais: "AIS 2015" };

export default function ValidationBanner({ stage, result }) {
  const [open, setOpen] = useState(false);

  if (stage) {
    return (
      <div className="flex items-center gap-3 bg-white border border-[#E5E0D8] rounded-md px-4 py-2.5 text-sm" data-testid="validation-progress">
        <CircleNotch size={16} className="animate-spin text-[#8C3A27]" />
        <Step label="1 · Drafting codes" active={stage === "drafting"} done={stage === "validating"} />
        <span className="text-[#E5E0D8]">—</span>
        <Step label="2 · Validating vs CDC ICD-10 / AIS 2015" active={stage === "validating"} />
      </div>
    );
  }

  const all = [...result.injuries, ...result.procedures, ...result.external_causes];
  const corrected = all.filter((c) => c.corrected_from || c.ais_corrected_from).length;
  const removed = result.removed || [];

  return (
    <div className="bg-[#E8EFEA]/60 border border-[#4A5D4E]/25 rounded-md px-4 py-2.5 text-sm text-[#2C332A]" data-testid="validation-summary">
      <div className="flex items-center gap-2">
        <ShieldCheck size={16} weight="fill" className="text-[#4A5D4E]" />
        <span className="font-semibold">Validated</span>
        <span className="text-[#5C665A]" data-testid="validation-counts">
          {all.length} codes · {corrected} corrected · {removed.length} removed
        </span>
        {removed.length > 0 && (
          <button onClick={() => setOpen((o) => !o)} className="ml-auto flex items-center gap-1 text-xs text-[#4A5D4E] hover:underline" data-testid="toggle-removed-codes">
            {open ? "Hide" : "Show"} removed <CaretDown size={12} className={open ? "rotate-180" : ""} />
          </button>
        )}
      </div>
      {open && (
        <ul className="mt-2 space-y-1" data-testid="removed-codes-list">
          {removed.map((r, i) => (
            <li key={i} className="text-xs text-[#5C665A]" data-testid={`removed-code-${i}`}>
              <span className="font-mono line-through text-[#8C3A27]">{r.code}</span>{" "}
              <span className="uppercase tracking-wider text-[10px]">{KIND_LABEL[r.kind] || r.kind}</span> · {r.reason}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

function Step({ label, active, done }) {
  return (
    <span className={`${active ? "text-[#8C3A27] font-semibold" : done ? "text-[#4A5D4E] line-through" : "text-[#5C665A]"}`}>
      {label}
    </span>
  );
}
